export type HoldingsApiPayload = {
  statusCode?: number;
  success?: number;
  message?: string;
  data?: {
    holdings?: unknown[];
    data?: unknown[];
    totalPages?: number;
    pageIndex?: number;
  };
  holdings?: unknown[];
  totalPages?: number;
  pageIndex?: number;
};

export const getHoldingsErrorMessage = (
  payload: unknown,
  fallback = "Failed to load holdings."
): string => {
  if (!payload || typeof payload !== "object") return fallback;
  const data = payload as HoldingsApiPayload;
  if (data.message) return data.message;
  return fallback;
};

export const isHoldingsApiError = (payload: unknown): boolean => {
  if (!payload || typeof payload !== "object") return false;
  const data = payload as HoldingsApiPayload;
  if (data.statusCode !== undefined && data.statusCode >= 400) return true;
  if (data.success !== undefined && data.success >= 400) return true;
  return false;
};

export const extractHoldingsList = (payload: HoldingsApiPayload | null | undefined): unknown[] => {
  if (!payload) return [];
  if (Array.isArray(payload.holdings)) return payload.holdings;

  const nested = payload.data;
  if (nested && Array.isArray(nested.holdings)) return nested.holdings;
  if (nested && Array.isArray(nested.data)) return nested.data;

  return [];
};

export const extractHoldingsPagination = (payload: HoldingsApiPayload | null | undefined) => ({
  totalPages: payload?.data?.totalPages ?? payload?.totalPages ?? 1,
  pageIndex: payload?.data?.pageIndex ?? payload?.pageIndex ?? 1,
});
